import { createInstanceWithChildren } from '../../../../utils/dynamic-items-utils';
import { CategorySelect } from '../../../components/selects/category-filter-select';
import { StoresSelect } from './stores-select';

export const PocketsFilters = createInstanceWithChildren({
  contentTypeId: 'dynamic-collections-renderer',
  styles: {
    classes: ['d-flex', 'px-3', 'py-2'],
  },
  children: [
    {
      id: 'date-range-filter',
      contentTypeId: 'dynamic-elements-input-date-range',
      inputs: {
        preselected: {
          provider: 'id:root',
          property: 'dateRangeStartWith',
          startWith: '',
        },
        allowWriteValueReset: true,
      },
    },
    {
      ...StoresSelect,
      styles: {
        classes: ['ml-2'],
      },
    },
    CategorySelect,
  ],
});
